'use es6';

import BasicInterstitial from '../BasicInterstitial';
import { jsx as _jsx } from "react/jsx-runtime";
const TrackIncompleteInterstitial = ({
  buttonI18n = 'learningCenter.tracks.interstitials.backToTracks',
  buttonLink = '/',
  hideButton = false
} = {}) => {
  return /*#__PURE__*/_jsx(BasicInterstitial, {
    buttonI18n: buttonI18n,
    buttonLink: buttonLink,
    buttonUse: "primary",
    headingI18n: "learningCenter.tracks.interstitials.trackIncomplete",
    hideButton: hideButton,
    pictogramName: "Schedule",
    subheadingI18n: "learningCenter.tracks.interstitials.trackIncompleteSubheading"
  });
};
export default TrackIncompleteInterstitial;